module.exports = __webpack_public_path__ + "img/gem_of_true_sight.460e95b5.png";